module.exports = __webpack_public_path__ + "img/post.c69efdd1.png";